import { render, staticRenderFns } from "./resources-editor-contracts.vue?vue&type=template&id=19bc94e2"
import script from "./resources-editor-contracts.vue?vue&type=script&lang=js"
export * from "./resources-editor-contracts.vue?vue&type=script&lang=js"
import style0 from "./resources-editor-contracts.vue?vue&type=style&index=0&id=19bc94e2&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports